import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-cap-client',
  templateUrl: './cap-client.component.html',
  styleUrls: ['./cap-client.component.css']
})
export class CapClientComponent implements OnInit {

  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();

  selected = [];
  dataArticle = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  condition1: Boolean = false;
  isHisto: Boolean = false;
  isEdit: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  devise;
  pays = '';
  focusIndex = 0;
  selectedRow: any = {};
  listCAP = [];
  listExutoire: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  typeContenant: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  artContenu: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
  listExutoireUlterieur: any = [{ id: 0, libelle: 'Par défaut', libelleObjetEntite: 'Par défaut' }];

  error = '';
  formatPerso = [];
  formatprs: String = '';

  @ViewChild('msg') msg;
  constructor(public common: CommonService, private modalService: BsModalService) {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise;
    this.adresseAchat = this.common.local.getObject('paramSociete').adresseAchat;
  }

  ngOnInit() {
    this.getListCAP().then(data => {
      this.isEmpty = false;
      this.parseDate();
    });
  }

  getpays(id) {
    let elt;
    this.common.getType('typePays').forEach(elem => {
      if (elem.id === id) {
        elt = elem;
      }
    });
    return elt;
  }

  parseDate() {
    this.listCAP.forEach(elt => {
      elt.modelDebut = this.common.parseDate(moment(elt.dateValidite, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
    });
  }

  hide() {
    this.show.emit();
  }

  showHisto() {
    this.isHisto = !this.isHisto;
    this.listCAP = [];
    this.getListCAP();
  }

  getListCAP() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBGetListCAPClient',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBGetListCAPClient'], this.detail, {
        'typeParam': 'boolean',
        'valeur': this.isHisto
      } ]
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      this.listCAP = datas.data || [];
      this.listCAP.forEach(elt => this.getLibelleContenant(elt.contenant));
      return datas.data;
    });
  }


  selectRow(row) {
    this.focusIndex = this.listCAP.indexOf(row);
    this.selected = [row];
  }

  inserteLigne() {
    this.listCAP.splice(this.focusIndex, 0, {
      id: '1', dateDebut: moment().format('DD/MM/YYYY HH:mm:ss'),
      dateFin: '31/12/9999'
    });
    const ctrl = this;
    setTimeout(function () {
      $('.article' + (ctrl.focusIndex)).focus();
    }, 600);
  }

  deleteLigne(row) {
    const temp = this.listCAP.filter(elt => elt !== row);
    this.listCAP = temp;
  }

  addLigne() {
    this.listCAP.push({
      index: this.listCAP.length, id: '1',
      dateDebut: moment().format('DD/MM/YYYY HH:mm:ss'), dateFin: '31/12/9999'
    });
    this.listCAP = [...this.listCAP]
    const length = this.listCAP.length - 1;
    setTimeout(function () {
      $('.article' + (length)).focus();
    }, 600);
  }

  searchArticle(event) {
    this.dataArticle = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
    const param =   1;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');;
      if (datas.data) {
        this.dataArticle = [...this.dataArticle, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchChantier(event) {
    this.listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        },
        'CRITERE': event || ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');;
      if (this.common.verifySession(datas)) {
        this.listChantier = [...this.listChantier, ...datas.data];
      }
    });
  }

  searchTypecontenant() {
    this.typeContenant = [{ id: 0, libelleObjetEntite: 'Tous' }];
    this.common.getType('listetypeContenant').forEach(elt => {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? (elt.uniteCont.libelle || '') : '');
      this.typeContenant.push(elt);
    });
  }

  searchExutoire(event) {
    const param = 6

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');;
      if (this.common.verifySession(datas)) {
        const l = [{ id: 0, libelleObjetEntite: 'Tous' }];
        l.push(...datas.data);
        this.listExutoire = l;
      }
    });
  }

  searchExutoireUlt(event) {
    const param = 6

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');;
      if (this.common.verifySession(datas)) {
        const l = [{ id: 0, libelle: 'Par défaut', libelleObjetEntite: 'Par défaut' }];
        l.push(...datas.data);
        this.listExutoireUlterieur = l;
      }
    });
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  calculMontant(row) {
    if (row.qte && row.tarif) {
      row.prixHT = row.qte * row.tarif;
    } else {
      row.prixHT = 0;
    }
  }

  changeDate(event, row) {
    if (moment(event).isValid()) {
      row['dateValidite'] = moment(event).format('DD/MM/YYYY');
    } else {
      row['dateValidite'] = moment().format('DD/MM/YYYY');
    }
    console.log(row['dateValidite']);
  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  showFormEdit(row) {
    this.selectedRow = Object.assign({}, row);
    if (this.selectedRow.id) {
      this.selectedRow.add = false;
    } else {
      this.selectedRow.add = true;
    }
    this.selectedRow.article = this.selectedRow.article || this.dataArticle[0];
    this.selectedRow.contenant = this.selectedRow.contenant || this.typeContenant[0];
    this.selectedRow.chantier = this.selectedRow.chantier || this.listChantier[0];
    this.selectedRow.exutoire = this.selectedRow.exutoire || this.listExutoire[0];
    this.selectedRow.exutoireUlterieur = this.selectedRow.exutoireUlterieur || this.listExutoireUlterieur[0];
    this.isEdit = !this.isEdit;
    if (this.isEdit) {
      this.searchTypecontenant();
    }
  }

  validerFormEdit() {
    const article = this.selectedRow['article'].id;
    const exutoire = this.selectedRow['exutoire'].id;
    const chantier = this.selectedRow['chantier'].id;
    let date = '';
    if (moment(this.selectedRow['modelDebut']).isValid()) {
      date = moment(this.selectedRow['modelDebut']).format('DD/MM/YYYY');
    } else {
      date = moment().format('DD/MM/YYYY');
    }
    this.selectedRow['dateValidite'] = this.selectedRow['dateValidite'] || date;
    const tempList = this.listCAP.filter(elt => elt.id !== this.selectedRow['id']);
    let isDouble = false;
    tempList.forEach(elt => {
      const art = elt.article ? elt.article.id : 0;
      const exu = elt.exutoire ? elt.exutoire.id : 0;
      const cht = elt.chantier ? elt.chantier.id : 0;

      if (art === article && exu === exutoire && cht === chantier) {
        isDouble = true;
      }

    });
    if (!isDouble) {
      this.saveModif();
    } else {
      this.error = `Votre CAP n'est pas valable;\n
      Il engendre une duplication des données.\n
      Veuillez ressaisir votre CAP.`;
      this.common.openModal(this.modalService, this.msg);
    }
  }

  getLibelleContenant(elt) {
    if (elt) {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? (elt.uniteCont.libelle || '') : '');
    }
  }

  saveModif() {
    this.selectedRow['nomclass'] = 'CAPClient';
    this.detail['nomclass'] = 'Client';
    this.isEdit = false;
    const param = {
      'servlet': 'DBMAJCAPClient',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBMAJCAPClient'], this.selectedRow, this.detail]
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        const etat =  this.selectedRow.id ? false : true;
        this.isEmpty = false;
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          } else {
            this.isEdit = false;
            this.selectedRow = {};
            this.getListCAP();
          }
      }
    });
  }

  exportXLS() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBExtraireCAPClientXLS',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data[0]) {
          this.common.openFile(datas.data[0]);
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }

}
